module.exports = __webpack_public_path__ + "static/img/bg_peitaochanyefuwu.428bce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/bg_peitaochanyefuwu.png
// module id = 69Wk
// module chunks = 1